module.exports = __webpack_public_path__ + "img/shg45_samurai02_shop.da888e6e.png";